import {createStore} from 'vuex';
import {auth} from './auth.module';
import {typo3} from './typo3.module';
import {icons} from './icons.module';
import {startpages} from './startpages.module';

const store = createStore({
	modules: {
		auth,
		typo3,
		icons,
		startpages,
	},
});

export default store;
